import { useCallback, useState } from 'react';
import { chooseBank } from '../../app/thunks/bank-selection.thunk';
import { useAppDispatch } from '../../app/hooks';
import { Bank, BankCountry } from '../../services/interfaces/bank.interface';

export type BankSession = {
	bank: Bank | null;
	onBankSelect(bank: Bank): void;
	onCountryChange(country: BankCountry): void;
};

export const useBankSession = (): BankSession => {
	const [bank, setBank] = useState<Bank | null>(null);
	const [country, setCountry] = useState<BankCountry>('AT');

	// flag indicating if selection request is in progress
	const [isSelecting, setIsSelecting] = useState<boolean>(false);

	const dispatch = useAppDispatch();

	const onBankSelect = useCallback(
		async (bank: Bank) => {
			if (isSelecting) return;

			setIsSelecting(true);
			setBank(bank);

			await dispatch(
				chooseBank({
					bank,
					country
				})
			);
		},
		[country, isSelecting]
	);

	return { bank, onBankSelect, onCountryChange: setCountry };
};
